var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "job",
    d: "M14,2.827a1.3,1.3,0,0,0-1.313-1.254H9.932v-.3A1.3,1.3,0,0,0,8.618,0H5.384A1.3,1.3,0,0,0,4.071,1.278v.3H1.313A1.3,1.3,0,0,0,0,2.827v8.681A.5.5,0,0,0,.505,12H13.495A.5.5,0,0,0,14,11.508V2.826ZM5.081,1.279a.3.3,0,0,1,.3-.3H8.618a.3.3,0,0,1,.3.3v.3H5.082v-.3ZM1.315,2.558H12.687a.3.3,0,0,1,.3.3,3.841,3.841,0,0,1-.885,2.831,2.381,2.381,0,0,1-1.715.612H8.316V6a.5.5,0,0,0-.505-.492H6.194A.5.5,0,0,0,5.688,6v.3H3.625A2.385,2.385,0,0,1,1.9,5.67a3.814,3.814,0,0,1-.886-2.815.3.3,0,0,1,.3-.3ZM6.7,6.491H7.3V7.869H6.7Zm6.293,4.525H1.011V6.182c.055.063.112.124.172.181a3.364,3.364,0,0,0,2.44.914H5.687V8.359a.5.5,0,0,0,.505.492H7.809a.5.5,0,0,0,.505-.492V7.277h2.12a3.931,3.931,0,0,0,.93-.106,3.117,3.117,0,0,0,1.455-.792c.06-.057.118-.119.172-.181v4.817Z",
    fill: "#00c22d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.e4cdd34fc5012734619e38b85d3c9d2c.svg";
export { ForwardRef as ReactComponent };